<div class="messages-list-container">
  <ng-container *ngIf="messages.length; else noCorrespondenceHistoryData">
    <table class="cg-datatable" data-test="correspondence-history">
      <thead>
        <tr>
          <th
            data-test="subject-header"
            class="cg-datatable__header nosort-header-container"
          >
            {{ 'shared.correspondenceHistory.headers.subject' | translate }}
          </th>
          <th
            data-test="generated-date-header"
            class="cg-datatable__header nosort-header-container"
          >
            {{
              'shared.correspondenceHistory.headers.generatedOnDate' | translate
            }}
          </th>
          <th
            data-test="correspondence-letter-header"
            class="cg-datatable__header nosort-header-container"
          >
            {{
              'shared.correspondenceHistory.headers.correspondenceLetter'
                | translate
            }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let correspondenceHistory of messages; index as i"
          data-test="correspondenceHistory"
        >
          <td class="cg-datatable__cell subject" data-test="subject">
            {{ correspondenceHistory.subject }}
          </td>
          <td
            class="cg-datatable__cell generated-date"
            data-test="generated-date"
          >
            {{ correspondenceHistory.generatedOn }}
          </td>
          <td class="cg-datatable__cell view-pdf-btn" data-test="view-pdf">
            <button
              cignaButton="link inline no-underline"
              target="_blank"
              (click)="viewPDF(correspondenceHistory)"
              data-test="view-pdf-btn"
              style="padding-left: 10px"
              class="cg-content-v2-link"
            >
              View PDF
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </ng-container>
</div>
<ng-template #loading>
  <div class="loading">
    <div class="cg-spinner"></div>
  </div>
</ng-template>
<ng-template #error let-e>
  <div
    *ngIf="e?.code || e?.status"
    data-test="error-msg"
    class="cg-error-msg-large cg-margin-bottom-lg"
  >
    <cigna-icon type="exclamation-circle"></cigna-icon>
    <div data-spa-service-error>
      {{ e.code ? e.code : e.status }}:
      <span> {{ e.errObject.message }} </span>
    </div>
  </div>
</ng-template>

<ng-template #noCorrespondenceHistoryData>
  <div class="no-messages">
    {{ 'shared.correspondenceHistory.noCorrespondenceData' | translate }}
  </div>
</ng-template>

<ng-container *ngIf="messages?.length">
  <div
    data-test="lbl-showing-results"
    class="cg-margin-top-md cg-color-gray-55"
    style="padding-left: 0.5em"
  >
    Showing {{ messages?.length }} results
  </div>
</ng-container>
